export default function(Cls, els) {
  const instances = [];
  if (els.length > 0) {
    for (let i = 0; i < els.length; i++) {
      const el = els[i];
      instances.push(new Cls(el));
    }
  }

  return instances;
}